import { Controller } from "@hotwired/stimulus";
import { closeModal, redirectToUrl } from "../utils/misc";

export default class extends Controller {
  static targets = ["loadingText"];

  connect() {
    this._subscribeToChannel();

    const timer = null;
    window.$(this.element).on("show.bs.modal", () => {
      this.fileDownloaded = false;
      this._setLoadingText("Nous préparons votre téléchargement, veuillez patienter…");
      this._scheduleLoadingTextUpdate(timer);
    });
  }

  _scheduleLoadingTextUpdate(timer) {
    clearTimeout(timer);
    setTimeout(() => {
      if (!this.fileDownloaded) {
        this._setLoadingText(
          "La préparation peut prendre un peu de temps si vos fichiers sont volumineux, merci de patienter encore un peu !"
        );
      }
    }, 10000);
  }

  _subscribeToChannel() {
    App.cable.subscriptions.create(
      { channel: "DownloadableZipfileChannel", stream_name: "downloadable_zipfile" },
      {
        received: (data) => {
          this._downloadFile(data.url);
        },
      }
    );
  }

  _downloadFile(fileUrl) {
    this._setLoadingText("Votre fichier est prêt, le téléchargement est en train de démarrer");
    redirectToUrl(fileUrl);
    this.fileDownloaded = true;

    setTimeout(() => {
      closeModal(this.element.id);
    }, 1000);
  }

  _setLoadingText(text) {
    this.loadingTextTarget.innerText = text;
  }
}
